import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const AiSummarizeColor16 = ({
  height = 16,
  width = 16,
  color = 'url(#paint0_linear_5410_7723)',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.81106 3.71533C9.22216 3.71533 9.55541 4.05112 9.55541 4.46533C9.55541 4.87955 9.22216 5.21533 8.81106 5.21533H2.72091C2.30982 5.21533 1.97656 4.87955 1.97656 4.46533C1.97656 4.05112 2.30982 3.71533 2.72091 3.71533H8.81106ZM5.25082 9.21533H2.72091C2.30982 9.21533 1.97656 8.87955 1.97656 8.46533C1.97656 8.05112 2.30982 7.71533 2.72091 7.71533L5.25082 7.71533C5.66191 7.71533 5.99517 8.05112 5.99517 8.46533C5.99517 8.87955 5.66191 9.21533 5.25082 9.21533ZM8.81106 13.2153H2.72091C2.30982 13.2153 1.97656 12.8795 1.97656 12.4653C1.97656 12.0511 2.30982 11.7153 2.72091 11.7153L8.81106 11.7153C9.22216 11.7153 9.55541 12.0511 9.55541 12.4653C9.55541 12.8795 9.22216 13.2153 8.81106 13.2153ZM12.3063 4.67341C12.1714 4.04016 11.2676 4.04016 11.1327 4.67341L10.8406 6.04379C10.6766 6.81338 10.0766 7.41528 9.3075 7.58168L7.93373 7.87892C7.30291 8.01541 7.30291 8.91529 7.93373 9.05178L9.3075 9.34902C10.0766 9.51542 10.6766 10.1173 10.8406 10.8869L11.1327 12.2573C11.2676 12.8905 12.1714 12.8905 12.3063 12.2573L12.5984 10.8869C12.7624 10.1173 13.3624 9.51542 14.1315 9.34902L15.5053 9.05178C16.1361 8.91529 16.1361 8.01541 15.5053 7.87892L14.1315 7.58168C13.3624 7.41528 12.7624 6.81338 12.5984 6.04379L12.3063 4.67341Z"
      fill={getColor(color, isColorInherited)}
      strokeOpacity="0"
      strokeWidth="0"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5410_7723"
        x1="14.4472"
        y1="3.71533"
        x2="8.11635"
        y2="15.6583"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF4D80" />
        <stop offset="0.0667" stopColor="#FE4D81" />
        <stop offset="0.1333" stopColor="#FC4E82" />
        <stop offset="0.2" stopColor="#F95086" />
        <stop offset="0.2667" stopColor="#F4528A" />
        <stop offset="0.3333" stopColor="#EE5490" />
        <stop offset="0.4" stopColor="#E65897" />
        <stop offset="0.4667" stopColor="#DE5B9F" />
        <stop offset="0.5333" stopColor="#D65FA7" />
        <stop offset="0.6" stopColor="#CE62AF" />
        <stop offset="0.6667" stopColor="#C666B6" />
        <stop offset="0.7333" stopColor="#C068BC" />
        <stop offset="0.8" stopColor="#BB6AC0" />
        <stop offset="0.8667" stopColor="#B86CC4" />
        <stop offset="0.9333" stopColor="#B66DC5" />
        <stop offset="1" stopColor="#B56DC6" />
      </linearGradient>
    </defs>
  </SvgIcon>
);
